exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body {\n  max-height: 300px;\n  overflow: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-add-question/modal-add-question.component.css
// module id = ../../../../../src/app/modules/dynamic-tips/tree-view/modal-add-question/modal-add-question.component.css
// module chunks = main